module.exports = __webpack_public_path__ + "fonts/sourcesansprobolditalic.2354f16c.woff2";